<!-- Created by henian.xu on 2020/10/27. -->

<template>
    <div
        class="enterprise-picker"
        @click="onSwitch"
    >
        <div :class="['out-show',{noop:!model || !model.length}]">
            <div class="inner">
                <div class="label">{{model || placeholder}}</div>
                <div
                    v-if="model && !disabled_ && !readonly_"
                    class="clear"
                    @click.stop="onClear">
                    <XIcon
                        content="f01a"
                        theme="g6"
                        size="big" />
                </div>
                <XIcon
                    content="f012"
                    theme="g6"
                    size="small" />
            </div>
        </div>

        <!--popup-->
        <transition :name="aniName">
            <Page
                ref="popup"
                class="popup"
                v-show="popupShow"
            >
                <PageBar class="pa-l pa-r">
                    <XInput
                        placeholder="请输入关键字"
                        v-model="keywords"
                        @input="onQueryInput"></XInput>
                </PageBar>
                <Container>
                    <CellGroup border>
                        <template v-if="listData&&listData.length">
                            <Cell
                                v-for="item in listData"
                                :key="item.id"
                                :label="item.name"
                                @click="onItem(item)"
                            ></Cell>
                        </template>
                        <Cell
                            v-else-if="keywords"
                            :label="keywords"
                            extra="使用输入值"
                            @click="onItem({name:keywords})"
                        ></Cell>
                    </CellGroup>
                </Container>
                <!--<PageBar position="bottom">
                    <XButton
                        class="item"
                        label="清空"
                        theme="second"
                        @click="()=>{onClear()}"
                    ></XButton>
                </PageBar>-->
            </Page>
        </transition>
    </div>
</template>

<script>
import { popupMixin } from 'packages/mixins';
import { debounce } from 'utils/Common';

export default {
    name: 'EnterprisePicker',
    mixins: [popupMixin],
    data() {
        return {
            keywords: '',
            listData: [],
        };
    },
    props: {
        value: {
            type: String,
            default: '',
        },
    },
    computed: {
        model: {
            get() {
                return this.value;
            },
            set(val) {
                this.$emit('input', val);
            },
        },
    },
    methods: {
        onQueryInput: debounce(function handler(val) {
            // this.keywords = val;
            console.log(val);
            this.getListData();
        }),
        async getListData(params) {
            const { keywords } = this;
            console.log(keywords.length);
            if (!keywords || keywords.length < 3) return null;
            const res = await this.$api.Member.Ex.OrderInvoice.enterpriseList({
                keywords,
                ...params,
            });
            if (!res.success) return null;
            this.listData = res.data;
            return res;
        },
        onItem(val) {
            this.model = val.name;
            this.$emit('change', val);
            this.close();
        },
        onClear() {
            this.model = '';
        },
    },
    created() {
        this.getListData();
    },
};
</script>

<style lang="scss">
.enterprise-picker {
    flex: 1;
    > .out-show {
        > .inner {
            line-height: $formItemHeight;
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            > .label {
                flex: 1;
            }
            > .clear {
                margin: 0 $margin-small;
            }
        }
        &.noop {
            > .inner {
                > .label {
                    color: $gray6;
                }
            }
        }
    }
}
</style>
